<div class="wrapper">
  <mat-card class="content">
    <mat-card-content>
      <h2 class="card-title">Uitzonderingen waarop je niet kunt (denk aan vakantie, tandarts etc.)</h2>
      @if (exceptions().length > 0) {
        <div class="list-items">
          <div class="list-item-wrapper headers">
            <div class="list-item-col-wrapper">
              <div class="list-item-col">Titel</div>
              <div class="list-item-col hide-column">Van</div>
              <div class="list-item-col">Tot</div>
              <div class="list-item-col"></div>
            </div>
          </div>
          <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
            @for (exception of exceptions(); track exception.index) {
              <div class="list-item-wrapper">
                <div
                  class="list-item-col-wrapper"
                  role="button"
                  [attr.tabindex]="userCanModify ? 0 : -1"
                  aria-label="Uitzondering openen"
                  [attr.aria-disabled]="!userCanModify"
                  (click)="!userCanModify ? null : openAddExceptionDialog(exception)"
                  (keydown.enter)="!userCanModify ? null : openAddExceptionDialog(exception)"
                  (keydown.space)="$event.preventDefault(); !userCanModify ? null : openAddExceptionDialog(exception)"
                >
                  <div class="list-item-col">
                    {{ exception.name }}
                  </div>
                  <div class="list-item-col hide-column">
                    {{ exception.dateFrom | date: 'dd-MM-yyyy HH:mm' }}
                  </div>
                  <div class="list-item-col hide-column">
                    {{ exception.dateTo | date: 'dd-MM-yyyy HH:mm' }}
                  </div>
                  <div class="list-item-col">
                    <div class="list-item-buttons">
                      <button mat-icon-button aria-label="Uitzondering bewerken" [disabled]="!userCanModify">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        aria-label="Uitzondering verwijderen"
                        (click)="deleteException(exception.index); $event.stopPropagation()"
                        [disabled]="!userCanModify"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="list-item-col-wrapper"></div>
              </div>
            }
          </cdk-virtual-scroll-viewport>
        </div>
      }
      @if (exceptions().length === 0) {
        <p class="no-exceptions">Er zijn nog geen uitzonderingen.</p>
      }
    </mat-card-content>
  </mat-card>
</div>
@if (userCanModify) {
  <button mat-fab extended color="primary" (click)="openAddExceptionDialog()">
    <mat-icon>add</mat-icon>
  </button>
}
